import { useAppSelector } from 'app/hooks';
import useSystemDesignBypassMode from 'hooks/use-system-design-bypass-mode';
import {
  selectDuctedPairLinkMode,
  selectIsDuctedDesignPending
} from 'utils/ducted-design';
import { TabLocks } from 'utils/system-design-bypass';
import { getTabLocks } from 'utils/tab-locks';

export default function useTabLocks(): TabLocks {
  const bypassMode = useSystemDesignBypassMode();
  const ductedDesignPending = useAppSelector(selectIsDuctedDesignPending);
  const ductedPairLinkMode = useAppSelector(selectDuctedPairLinkMode);
  return getTabLocks({ bypassMode, ductedDesignPending, ductedPairLinkMode });
}
